/*
  Выбор счетов для переноса вкладки «Файлы» (16.10.2026).

  Счета для окна - готовые к переносу, с адресом и должником из файлов
  (`GET /uploads/choices`). Спрашиваются по нажатию «Выбрать счета…», а не
  заранее: накопитель бывает в тысячи счетов, а окно открывают не каждый раз.

  Число готовых изменилось (перенос прошёл, пришёл новый файл) - перечень для
  окна перечитывается при следующем открытии, а ВЫБОР остаётся: «Объём ожидаем,
  перенести» после отказа сторожа обязан повторить перенос тех же счетов, а не
  унести все готовые (находка проверки 16.10.2026). Номер, переставший быть
  готовым, сервер просто не перенесёт.
*/

import { useEffect, useState } from 'react'

import { api } from '../../api/client.js'

export default function useTransferPick(ready) {
  const [choices, setChoices] = useState(null)
  const [only, setOnly] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    setChoices(null)
  }, [ready])

  async function need() {
    setError(null)
    try {
      setChoices(await api.uploadChoices())
      return true
    } catch (failure) {
      setError(failure)
      return false
    }
  }

  return { choices, only, setOnly, need, error }
}
